import { Button, Heading, Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { useCurrentRewardTier } from 'hooks/useCurrentRewardTier';
import { tradeSharedContent } from '../../tradeShared.content';
import { content } from './InfoModal.content';

const InfoModal = ({
  isOpen,
  infoType,
  onClose,
}: {
  isOpen: boolean;
  infoType: 'tradePrice' | 'rewardLevel' | 'tradingFee' | 'smartTrade';
  onClose: () => void;
}) => {
  const localizedContent = useContent(content, tradeSharedContent);

  const { currentTier, isLoading: isLoadingRewards } = useCurrentRewardTier();

  const titles = {
    tradePrice: localizedContent.tradePrice,
    rewardLevel: localizedContent.rewardLevel,
    smartTrade: localizedContent.smartTrade,
    tradingFee: localizedContent.tradingFee,
  };
  const subtitles = {
    tradePrice: localizedContent.tradePriceSubtitle,
    rewardLevel: localizedContent.rewardLevelSubtitle,
    smartTrade: localizedContent.smartTradeSubtitle,
    tradingFee: currentTier?.tierName
      ? localizedContent.tradingFeeSubtitle(
          currentTier?.tierName?.trim?.(),
          currentTier?.percentOff ?? 0,
        )
      : '',
  };

  const title = titles[infoType];
  const subtitle = subtitles[infoType];
  return (
    <DialogOrBottomSheet
      isOpen={isOpen}
      blurEnabled={true}
      onClose={onClose}
      backgroundColor="#0C1C2C">
      <div className="flex flex-col my-4 w-full items-center px-4">
        <Heading level={4}>{title}</Heading>
        <Typography
          size="large"
          weight="medium"
          className="my-8 text-center text-[#A4A7C1]">
          {subtitle}
        </Typography>
        <Button
          color="primary"
          size="large"
          text={localizedContent.gotIt}
          onPress={onClose}
          className="w-full"
        />
      </div>
    </DialogOrBottomSheet>
  );
};

export default InfoModal;
